import React, { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { RadioButton } from "primereact/radiobutton";
import classNames from "classnames";

interface Props {
  pergunta: any;
  onChange: any;
  send: any;
}

export default function PerguntaEvento({ pergunta, onChange, send }: Props) {
  const [value, setValue] = useState("");

  const change = (_value: any) => {
    onChange(_value);
    setValue(_value);
  };

  const getQuestionNumber = () => {
    return pergunta.cdSeqPergunta;
  };

  if (pergunta.cdSeqPergunta === 5) {
    return (
      <div className="pergunta-item pergunta-item--textarea">
        <div className="pergunta-item__header">
          <span className="pergunta-item__number">{getQuestionNumber()}</span>
          <label className="pergunta-item__label">{pergunta.dsPergunta}</label>
        </div>
        <div className="pergunta-item__content">
          <InputTextarea
            className="pergunta-item__textarea"
            value={value}
            onChange={(e) => {
              change(e.target.value);
            }}
            placeholder="Digite sua sugestão ou comentário..."
            rows={4}
            autoResize
          />
        </div>
      </div>
    );
  }

  const slice = pergunta.dsPergunta.split(";");

  const getEmojiRating = (rating: string) => {
    const emojis = ["😞", "😐", "🙂", "😊", "🤩"];
    return emojis[parseInt(rating) - 1] || "";
  };

  return (
    <div
      className={classNames("pergunta-item", {
        "pergunta-item--error": send && !value,
      })}
    >
      <div className="pergunta-item__header">
        <span className="pergunta-item__number">{getQuestionNumber()}</span>
        <label
          className={classNames("pergunta-item__label", {
            "pergunta-item__label--error": send && !value,
          })}
        >
          {slice[0]}
        </label>
      </div>
      <div className="pergunta-item__content">
        <div className="pergunta-item__rating">
          <label className="pergunta-item__label-side">{slice[1]}</label>
          <div className="pergunta-item__options">
            {[1, 2, 3, 4, 5].map((num) => (
              <label key={num} className="pergunta-item__option">
                <RadioButton
                  value={String(num)}
                  onChange={(e) => change(e.value)}
                  checked={value === String(num)}
                />
                <span
                  className={classNames("pergunta-item__emoji", {
                    "pergunta-item__emoji--active": value === String(num),
                  })}
                >
                  {getEmojiRating(String(num))}
                </span>
              </label>
            ))}
          </div>
          <label className="pergunta-item__label-side">{slice[2]}</label>
        </div>
        {send && !value && (
          <span className="pergunta-item__error-msg">
            Por favor, selecione uma opção
          </span>
        )}
      </div>
    </div>
  );
}
